import * as _types from "../_constants/types";
import ws from "../_constants/webservices";

export const getTicket = ticketId => dispatch => {
    dispatch({ type: _types.TICKET_FETCHING });

    let url = `/tickets/${ticketId}`;

    ws.rma.get(url, ws.rma.abortAndGetNewSignal("TICKET_FETCHING")).then(
        response => {
            if (response.status === 200) {
                response.json().then(json => {
                    dispatch({ type: _types.TICKET_LOAD, data: json });
                    dispatch({ type: _types.TICKET_UPDATE_LOAD, data: json });
                    dispatch({ type: _types.TICKET_FETCHING_COMPLETED });
                });
            } else if (response.status === 401) {
                dispatch({ type: _types.TICKET_FETCHING_FAILED, err: "Authentication Error" });
            } else {
                dispatch({ type: _types.TICKET_FETCHING_FAILED, err: "error" });
            }
        },
        error => {
            if (error.code === 20) {
                dispatch({ type: _types.TICKET_FETCHING_CANCELLED, err: error.message });
            } else {
                dispatch({ type: _types.TICKET_FETCHING_FAILED, err: error.message ? error.message : "error" });
            }
        }
    );
};

export const resetTicket = () => dispatch => {
    dispatch({ type: _types.TICKET_RESET });
};

export const updateTicket = (ticketId, ticket) => dispatch => {
    dispatch({ type: _types.TICKET_UPDATING });

    let url = `/tickets/${ticketId}`;

    ws.rma.put(url, ws.rma.abortAndGetNewSignal("TICKET_UPDATING"), JSON.stringify(ticket)).then(
        response => {
            if (response.status === 200) {
                response.json().then(json => {
                    dispatch({ type: _types.TICKET_LOAD, data: json });
                    dispatch({ type: _types.TICKET_UPDATE_LOAD, data: json });
                    dispatch({ type: _types.TICKET_UPDATING_COMPLETED });
                });
            } else {
                if (response.status === 400) {
                    response.json().then(json => {
                        dispatch({ type: _types.TICKET_UPDATE_LOAD, data: json });
                        dispatch({ type: _types.TICKET_UPDATING_FAILED, err: "error" });
                    });
                } else if (response.status === 401) {
                    dispatch({ type: _types.TICKET_UPDATING_FAILED, err: "Authentication Error" });
                } else {
                    dispatch({ type: _types.TICKET_UPDATING_FAILED, err: "error" });
                }
            }
        },
        error => {
            if (error.code === 20) {
                dispatch({ type: _types.TICKET_UPDATING_CANCELLED, err: error.message });
            } else {
                dispatch({ type: _types.TICKET_UPDATING_FAILED, err: error.message });
            }
        }
    );
};

export const getReturnLabel = (ticketId, requestId) => dispatch => {
    dispatch({ type: _types.RETURN_LABEL_FETCHING });

    let filename = "";
    let url = `/tickets/${ticketId}/return-label?request_id=${requestId}`;

    ws.rma.get(url, ws.rma.abortAndGetNewSignal("RETURN_LABEL_FETCHING")).then(
        response => {
            if (response.status === 200) {
                filename = response.headers.get("Filename") ? response.headers.get("Filename") : "bad_file_name";
                response.blob().then(blob => {
                    const href = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = href;
                    link.setAttribute("download", filename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                });
                dispatch({ type: _types.RETURN_LABEL_FETCHING_COMPLETED });
            } else if (response.status === 401) {
                dispatch({ type: _types.RETURN_LABEL_FETCHING_FAILED, err: "Authentication Error" });
            } else {
                dispatch({ type: _types.RETURN_LABEL_FETCHING_COMPLETED, err: "error" });
            }
        },
        error => {
            if (error.code === 20) {
                dispatch({ type: _types.RETURN_LABEL_FETCHING_CANCELLED, err: error.message });
            } else {
                dispatch({ type: _types.RETURN_LABEL_FETCHING_FAILED, err: error.message });
            }
        }
    );
};

export const searchTicket = (ticketNumber, emailAddress) => dispatch => {
    dispatch({ type: _types.TICKET_SEARCHING });

    let url = `/tickets/search`;
    let data = JSON.stringify({ ticket_number: ticketNumber, email_address: emailAddress });

    ws.rma.post(url, ws.rma.abortAndGetNewSignal("TICKET_SEARCHING"), data).then(
        response => {
            if (response.status === 200) {
                response.json().then(json => {
                    dispatch({ type: _types.TICKET_SEARCH_LOAD, data: json });
                    dispatch({ type: _types.TICKET_SEARCHING_COMPLETED });
                });
            } else if (response.status === 401) {
                dispatch({ type: _types.TICKET_SEARCHING_FAILED, err: "Authentication Error" });
            } else if (response.status === 404) {
                dispatch({ type: _types.TICKET_SEARCHING_FAILED, err: "NOT_FOUND" });
            } else {
                response.json().then(json => {
                    dispatch({ type: _types.TICKET_SEARCHING_FAILED, data: json, err: "error" });
                });
            }
        },
        error => {
            if (error.code === 20) {
                dispatch({ type: _types.TICKET_SEARCHING_CANCELLED, err: error.message });
            } else {
                dispatch({ type: _types.TICKET_SEARCHING_FAILED, err: error.message ? error.message : "error" });
            }
        }
    );
};

export const verifyTicket = ticketId => dispatch => {
    dispatch({ type: _types.TICKET_VERIFYING });

    let url = `/tickets/${ticketId}/verify`;

    ws.rma.get(url, ws.rma.abortAndGetNewSignal("TICKET_VERIFYING")).then(
        response => {
            if (response.status === 200) {
                response.json().then(json => {
                    dispatch({ type: _types.TICKET_VERIFY_DATA_LOAD, data: json });
                    dispatch({ type: _types.TICKET_VERIFYING_COMPLETED });
                });
            } else {
                dispatch({ type: _types.TICKET_VERIFYING_FAILED, err: "BAD_DATA" });
            }
        },
        error => {
            dispatch({ type: _types.TICKET_VERIFYING_FAILED, err: error.message ? error.message : "error" });
        }
    );
};

export const setTicketUpdate = ticket => dispatch => {
    dispatch({ type: _types.TICKET_UPDATE_LOAD, data: ticket });
};
